import { render, staticRenderFns } from "./fcwpHomePoster.vue?vue&type=template&id=f2c52b18&"
import script from "./fcwpHomePoster.vue?vue&type=script&lang=js&"
export * from "./fcwpHomePoster.vue?vue&type=script&lang=js&"
import style0 from "./fcwpHomePoster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports